export const SENTENCES = {
  renvoyerLeCode: 'Renvoyer le code',
  codeDactivation: "Code d'activation",
  activezVotreCompte: 'Activez votre compte',
  entrezVotreCode: 'Entrez votre code',
  seConnecter: 'Se connecter',
  motDePasseOublie: 'Mot de passe oublié ?',
  seSouvenirDeMoi: 'Se souvenir de moi',
  entrezVotreEmail: 'Veuillez entrer votre email',
  entrezVotreMotDePasse: 'Veuillez entrer votre mot de passe',
  entrezVotreNom: 'Vous devez entrer votre nom',
  connectezVous: 'Connectez-vous',
  emailInvalide: "L'email n'est pas valide",
  email: 'Email',
  nom: 'Nom',
  matricule: 'Matricule',
  emailEnvoye: 'Email envoyé',
  motDePasse: 'Mot de passe',
  mdpDifferent: 'Les mots de passes sont differents',
  mdp6char: 'Le mot de passe doit faire au moins 6 caractères',
  auMoins6Char: 'Au moins 6 caractères',
  annuler: 'Annuler',
  erreur: 'Une erreur est survenue',
  erreurReessayerOuContacter: "Merci de réessayer plus tard ou contacter l'administrateur du site",
  aSurveiller: 'A surveiller',
  emailEnvoyeA: (email: string) => `Un email vient de d'être envoyé à l'adresse ${email}`,
}

export const PDF_WIDTH = 595
export const PDF_HEIGHT = 842

// '@primary-color': '#91c800',
// '@layout-sider-background': '#505050',
// '@layout-header-background': '#505050',
// '@menu-item-color': '#fff',
// '@darkest-grey': '#444',
// '@light-grey': '#505050',
// '@lightest-grey': '#f5f5f5',
export const DATE_FORMAT = 'DD-MM-YYYY'

export const COLOR = {
  green: '#91c800',
  blue: '#1890ff',
  yellow: '#f0b506',
  red: '#da0d0d',
  white: '#fff',
  grey: '#505050',
  lightestGrey: '#f5f5f5',
  lightGrey: '#505050',
  darkestGrey: '#444',
}

export const FALLBACK_IMG =
  'data:image/png;base64,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'

export const FILE_UPLOADS_URL = 'https://vision.d4immobilier.fr/uploads/'
export const AWS_S3_URL = `https://${process.env.REACT_APP_S3_BUCKET}.s3.eu-west-3.amazonaws.com/`
export const AWS_S3_RESIZED_URL = `https://${process.env.REACT_APP_S3_BUCKET}-resized.s3.eu-west-3.amazonaws.com/`

export const TYPE_DE_VOIE: Record<number, string> = {
  0: 'rue',
  1: 'boulevard',
  2: 'avenue',
  3: 'traverse',
  4: 'chemin',
  5: 'impasse',
  6: 'allee',
  7: 'quartier',
  8: 'route',
  9: 'lotissement',
  10: 'montee',
  11: 'cours',
  12: 'promenade',
  13: 'place',
  14: 'quai',
  15: 'faubourg',
  16: '',
  17: 'allees',
  18: 'passage',
}

export const ETAT_DEMANDE_COLOR: { [key: number]: string } = {
  0: COLOR.blue,
  1: COLOR.darkestGrey,
  2: COLOR.green,
  3: COLOR.yellow,
  4: COLOR.red,
}

export const FORM_FIELDS = {
  username: 'username',
  password: 'password',
  confirmPassword: 'confirmPassword',
  email: 'email',
  name: 'name',
  remember: 'remember',
  activationCode: 'activationCode',
  matricule: 'matricule',
}

export const TYPE_AUDIENCE = {
  0: 'Conférence Présidentielle',
  1: 'Mise en état',
  2: 'Plaidoirie',
} as any

export const EtatRappelTelephonique = {
  '0': 'OK',
  '1': 'MESSAGE_LAISSE',
  '2': 'INVESTIGATIONS_A_MENER',
  '3': 'ATTENTE_INFO_APPELANT',
  '4': 'AUTRE',
  '5': 'MESSAGE_TRAITE_SANS_RAPPEL',
  '6': 'REPONSE_FAITE_PAR_MAIL',
} as any
